import { useQuery } from '@tanstack/react-query'
import { StorageKey } from '@/client/types'
import { getStates } from '@/infra/services'

export const useGetStates = (countryId: string = '') =>
  useQuery([StorageKey.STATES, countryId], () => getStates(countryId), {
    enabled: !!countryId,
    refetchOnWindowFocus: false
  })
